import { useWebSocketApi } from '@e3dc-react/shell/Hooks'
import { SocketStateModel } from '@e3dc-react/shell/Hooks/use-websocket-api'
import { isUndefined } from 'lodash'
import { VehicleInformationSocketModel } from '../models'
import { VehicleInformationSocketDto } from '../dto'
import { transformVehicleInformationSocketDtoToModel } from '../transformer'
import useUserVehicles from './use-user-vehicles'

const SERVICE_ID = '[VEHICLE INTEGRATION]'

/**
 * This hook provide information of all the vehicles of the user
 * through a websocket connection.
 */
export const useVehiclesInformationSocket = (installationId: number | undefined): SocketStateModel<VehicleInformationSocketModel[]> => {
  const vehiclesWebSocketApiPath = `vehicles/installations/${installationId}/vehicles/ws`
  const { vehicles } = useUserVehicles(installationId)
  const userHasVehicle = vehicles && vehicles.length > 0

  const { socketState } = useWebSocketApi<VehicleInformationSocketModel[], VehicleInformationSocketDto[]>({
    apiResourcePath: vehiclesWebSocketApiPath,
    loggerKey: SERVICE_ID,
    transformer: transformVehicleInformationSocketDtoToModel,
    dependencies: [installationId],
    doNotInitialize: isUndefined(installationId) || !userHasVehicle,
    endpoint: process.env.REACT_APP_VEHICLES_ENDPOINT ?? '',
  })

  return socketState
}
